import React from 'react';
import BaseCompetency from '../Application/BaseCompetency';
import { OTA_COMPETENCY_ITEMS } from './otaConstants';

const OtaCompetency = ({ targetUserId, onClose }) => {
    return (
        <BaseCompetency
            role="OTA"
            title="OTA CLINICAL COMPETENCY ASSESSMENT"
            items={OTA_COMPETENCY_ITEMS}
            totalPages={4}
            apiEndpoint="/competencies"
            fetchEndpoint="/competencies"
            targetUserId={targetUserId}
            onClose={onClose}
        />
    );
};

export default OtaCompetency;
